import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment } from '@angular/router';
import { AuthenticationService } from '../services';

@Injectable({ providedIn: 'root' })
export class AccessAllowedCanLoadGuard implements CanLoad {
    constructor(private authentication: AuthenticationService, private router: Router) {}

    async canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {
        const scopeKey = route.data.scopeKey;
        const isAuthenticated = await this.authentication.isAuthenticated();

        if (!isAuthenticated) {
            this.router.navigate(['/authentication']);
            return false;
        }

        // verifies if this route scope key is present on the current user authorized access scope
        const hasAccess = this.authentication.user.role.accessScope.indexOf(scopeKey) >= 0;

        if (!hasAccess) {
            this.router.navigate(['/']);
            return false;
        }

        return true;
    }
}
